import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OperacaoFinanceiraInserirComponent } from './operacao-financeira-inserir.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: OperacaoFinanceiraInserirComponent }
    ])],
    exports: [RouterModule]
})
export class OperacaoFinanceiraInserirRoutingModule { }
